import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Translate from 'translate';
import { Form } from 'react-form';
import { FormGroup, Text, Select, InputDate } from 'components/FormElements';
import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import StuckService from 'services/StuckService';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import LogDetail from '../../../components/Management/StuckDetail';
import DeleteModal from 'components/HTMLElements/DeleteModal';
import RelaunchModal from 'components/HTMLElements/DeleteModal';
import NotificationSmsFailed from 'material-ui/svg-icons/notification/sms-failed';

class Stucks extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {},
      statusId: null,
      queueId: null,
      incmsData: [],
      systemData: [],
      sources:[],
      statuses:[
        {id:'finished', name:'finished'},
        {id:'running', name:'running'},
        {id:'failed', name:'failed'},
        {id:'canceled', name:'canceled'},
        {id:'pending', name:'pending'},
      ],
      queues:[
        {id:'twitter_message', name:'twitter_message', source:'twitter'},
        {id:'twitter_replay', name:'twitter_replay', source:'twitter'},
        {id:'facebook_message', name:'facebook_message', source:'facebook'},
        {id:'facebook_comment', name:'facebook_comment', source:'facebook'},
        {id:'email_message', name:'email_message', source:'email'},
        {id:'email', name:'email', source:'email'},
        {id:'social_email', name:'social_email', source:'email'},
        {id:'social_email_sync_contacts', name:'social_email_sync_contacts', source:'email'},


        {id:'social_twitter_conversation', name:'social_twitter_conversation', source:'twitter'},
        {id:'social_twitter_hastag', name:'social_twitter_hastag', source:'twitter'},
        {id:'social_twitter_mentions', name:'social_twitter_mentions', source:'twitter'},
        {id:'social_facebook_conversation', name:'social_facebook_conversation', source:'facebook'},
        {id:'social_facebook_feed', name:'social_facebook_feed', source:'facebook'},
      
      ],
      logDetailModalOpened: false,
      systemLogDetailModalOpened: false,
      deleteModalOpened: false,
      disruptedModalOpened: false,
    };
    this.logEntity = {};
    this.systemLogEntity = {};
    this.deleteEntity = this.deleteEntity.bind( this );
    this.disrupted = this.disrupted.bind( this );
    this.toggleDeleteModal = this.toggleDeleteModal.bind( this );
    this.toggleDisruptedModal = this.toggleDisruptedModal.bind( this );

  }
  componentDidMount() {
    const {chatActive, phoneActive} = this.props;
    let sources = [        
      {id:'facebook',name:'facebook'},
      {id:'twitter',name:'twitter'},
      {id:'email',name:'email'},
    ];

    let queues = [
      {id:'twitter_message', name:'twitter_message', source:'twitter'},
      {id:'twitter_replay', name:'twitter_replay', source:'twitter'},
      {id:'facebook_message', name:'facebook_message', source:'facebook'},
      {id:'facebook_comment', name:'facebook_comment', source:'facebook'},
      {id:'email_message', name:'email_message', source:'email'},
      {id:'email', name:'email', source:'email'},
      {id:'social_email', name:'social_email', source:'email'},
      {id:'social_email_sync_contacts', name:'social_email_sync_contacts', source:'email'},


      {id:'social_twitter_conversation', name:'social_twitter_conversation', source:'twitter'},
      {id:'social_twitter_hastag', name:'social_twitter_hastag', source:'twitter'},
      {id:'social_twitter_mentions', name:'social_twitter_mentions', source:'twitter'},
      {id:'social_facebook_conversation', name:'social_facebook_conversation', source:'facebook'},
      {id:'social_facebook_feed', name:'social_facebook_feed', source:'facebook'},
    
    ]
    if (chatActive){
      sources.push( {id:'chat',name:'chat'})
      
      queues.push( {id:'social_chat', name:'social_chat', source:'chat'})
    }

    if (phoneActive){
      sources.push( {id:'phone',name:'phone'})
      queues.push( {id:'social_phone_sms', name:'social_phone_sms', source:'phone'})
      queues.push( {id:'phone_sms', name:'phone_sms', source:'phone'})
    }
    this.setState({sources, queues});
  }
  getIncmsLogs = ( params, cb ) => {
    const { toggleLoading } = this.props;
    const {statusId, queueId} = this.state;
    this.incmsParams = params;
    toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: ( params.page * params.pageSize ),
    };
    // apiParams[`filters[originIn]`] = ['incms', 'ims'];
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';
    else apiParams[`sortby[createdAt]`] = 'DESC';
    if (statusId)  apiParams[`filters[state]`] = statusId;
    if (queueId) apiParams[`filters[queues]`] = queueId;
    //apiParams[`filters[queue][]`] = 'social_twitter_conversation';
    StuckService.getLogs( apiParams ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data );

      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          incmsData: response.data.data[0] || [],
          pages: Math.ceil( response.data.total / params.pageSize ),
          total: response.data.total,
        } );
      }
    } )
  };
  toggleDeleteModal( entityId ) {
    this.entityToDelete = entityId;
    this.setState( { deleteModalOpened: !this.state.deleteModalOpened } )
  };
  toggleDisruptedModal( entityId ) {
    this.entityToRelaunch = entityId;
    this.setState( { disruptedModalOpened: !this.state.disruptedModalOpened } )
  };
  deleteEntity() {
    this.props.toggleLoading( true );

    StuckService.delete( this.entityToDelete ).then( ( response ) => {
      if( response.errors ) {
        this.props.toggleLoading( false );
        return this.props.toggleAlertError( response.errors );
      }

      this.toggleDeleteModal();
      this.getIncmsLogs( this.incmsParams )
    } )
  }
  disrupted() {
    this.props.toggleLoading( true );

    StuckService.disrupted( this.entityToRelaunch ).then( ( response ) => {
      if( response.errors ) {
        this.props.toggleLoading( false );
        return this.props.toggleAlertError( response.errors );
      }

      this.toggleDisruptedModal();
      this.getIncmsLogs( this.incmsParams )
    } )
  }
  getSystemLogs = ( params ) => {
    const { toggleLoading } = this.props;
    toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: ( params.page * params.pageSize ),
    };
    apiParams[`filters[origin]`] = 'system';
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';
    else apiParams[`sortby[createdAt]`] = 'DESC';

    ConfigurationService.getLogs( apiParams ).then( ( response ) => {
      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          systemData: response.data.data[0] || [],
          systemPages: Math.ceil( response.data.total / params.pageSize ),
          systemTotal: response.data.total,
        } );
      }
    } )
  };

  toggleLogDetailModal = ( item ) => {
    this.logEntity = item;
    this.setState( { logDetailModalOpened: !this.state.logDetailModalOpened } )
  };

  toggleSystemLogDetailModal = ( item ) => {
    this.systemLogEntity = item;
    this.setState( { systemLogDetailModalOpened: !this.state.systemLogDetailModalOpened } )
  };
  handleChangeStatus = e => {
    this.setState({ statusId: e});
  };
  handleChangeQueue = e => {
    let x = []
    _.map( e, ( item, index ) => {
      x[index]=_.get( item, 'id' )

    });
    this.setState({ queueId: x});
  };
  handleChangeQueue1 = e => {
    this.setState({ queueId: e});
  };
  handleChangeService = e => {
    this.setState({ serviceId: e.target.value });
  };

  handleChangeSource = e => {
    const { queues } = this.state
    let x = []
    let a = _.filter( queues, {source: e})
    _.map( a, ( item, index ) => {
      x[index]=_.get( item, 'id' )

    });
    this.setState({ queueId: x});
  };

  submitForm = data => {
    this.search = data;
    //this.getReport(this.params);
  };
  render() {
    const { incmsData, systemData, systemPages, systemTotal, logDetailModalOpened, systemLogDetailModalOpened,statuses, queues, sources } = this.state;

    return (
      <div>
        <div className="box box-default">
          <div className="box-header d-flex justify-content-between">
            <span className="text-capitalize"><Translate id="stuckListTitle"/></span>
            <button className="btn btn-info ml-2" onClick={() => this.getIncmsLogs(this.incmsParams)}>
              <Translate id="reload"/>
            </button>
            
          </div>
          <div className="box-body">
            <div>
              <Form onSubmit={this.submitForm}>
                {({ setValue, submitForm }) => (
                  <form onSubmit={submitForm} className="d-flex">
                    <FormGroup containerClass="col-md-3">

                      <label className={'MuiFormLabel-root MuiInputLabel-shrink'} ><Translate id="state"/></label>
                      <Select field="statusId" className="form-control" 
                              placeholder={<Translate id="report.selectSource" />}
                              labelKey="name"
                              valueKey="id"
                              simpleValue={true}  
                              onChange={this.handleChangeStatus}
                              options={statuses}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-2">

                      <label className={'MuiFormLabel-root MuiInputLabel-shrink'} ><Translate id="report.source"/></label>
                      <Select field="serviceId" className="form-control" 
                              placeholder={<Translate id="report.selectSource" />}
                              labelKey="name"
                              valueKey="id"
                              simpleValue 
                              onChange={(e)=>{
                                const resQueue = _.filter( queues, {source: e})
                                setValue( 'queueId', resQueue );
                                this.handleChangeSource(e)}}
                              options={sources}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-4">

                      <label className={'MuiFormLabel-root MuiInputLabel-shrink'} ><Translate id="report.queue"/></label>
                      <Select field="queueId" className="form-control" 
                              placeholder={<Translate id="report.selectSource" />}
                              labelKey="name"
                              valueKey="id"
                              simpleValue={false} multi 
                              onChange={this.handleChangeQueue}
                              options={queues}/>
                    </FormGroup>

                    <div className="col-md-4 pl-0">
                      <button
                        style={{ marginTop: '20px', marginLeft: '0px' }}
                        type="submit"
                        className="btn btn-info mr-2 px-3"
                        onClick={() => {
                          this.search = {};
                          this.download = '';
                          this.getIncmsLogs( this.incmsParams )
                          //this.getReport(userId, serviceId);
                        }}
                      >
                        <i className="fa fa-search pointer" />
                      </button>
                    </div>

                    <div className="col-md-2 pl-0 text-right">


                      
                    </div>


                  </form>
                )}
              </Form>
            </div>
            <AsyncTable className="app-table-white"
                        onFetchData={this.getIncmsLogs}
                        rowsText="Jobs"
                        {...this.state}
                        data={incmsData}
                        columns={[

                          { Header: <Translate id="queue"/>, accessor: 'queue',  },
                          { Header: <Translate id="command"/>, accessor: 'command', },
                          { Header: <Translate id="state"/>, accessor: 'state', maxWidth: 100, },
                          { Header: <Translate id="stuckError"/>, accessor: 'errorOutput',  },
                          {
                            Header: <Translate id="stuckCreateAt"/>, accessor: 'createdAt', maxWidth: 160,
                            Cell: props => moment( props.value ).format( 'DD/MM/YYYY hh:mm A' )
                          },
                          {
                            Header: '', accessor: 'id', maxWidth: 100,
                            Cell: props =>
                              <div>
                                <button className="btn btn-outline-info btn-sm mr-2"
                                       onClick={() => this.toggleLogDetailModal( props.original )}>                               
                                    <i className="fa fa-info-circle"/>
                                </button>
                                <button className="btn btn-outline-info btn-sm ml-2" disabled={( props.original.state !== 'pending' && props.original.state !== 'running' ) }
                                        onClick={( props.original.state === 'pending'  || props.original.state === 'running') ? () => this.toggleDisruptedModal( props.value ) : () => {}}>
                                  {!props.original.active
                                    ? <i className="fa fa-ban"/> : <i className="fa fa-ban"/>}
                                </button>
                                {/**
                                <button className="btn btn-outline-danger btn-sm"
                                        onClick={() => this.toggleDeleteModal( props.value )}>
                                  <i className="fa fa-trash"/>
                                </button>
                             
                                  **/}
                              </div>
                          },
                        ]}
                  />
          </div>
        </div>

        <LogDetail open={logDetailModalOpened}
                   data={this.logEntity}
                   onClose={this.toggleLogDetailModal}
        />
        <DeleteModal onConfirm={this.deleteEntity}
                     opened={this.state.deleteModalOpened}
                     onToggle={this.toggleDeleteModal}
        />
        <RelaunchModal onConfirm={this.disrupted}
                     opened={this.state.disruptedModalOpened}
                     onToggle={this.toggleDisruptedModal}
                     label={<Translate id="disruptedConfirm"/>}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  isLoading: state.settings.isLoading,
  chatActive: state.settings.chatActive,
  phoneActive: state.settings.phoneActive,
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Stucks );



// WEBPACK FOOTER //
// ./routes/app/routes/management/stucks/index.js